import React from "react";
import { Form } from "react-bootstrap";

// Generic enough to live in ../../lib/components if you want to share it.
export function Field({ label, children, className = "" }) {
  return (
    <div className={`d-flex flex-column gap-1 ${className}`.trim()}>
      <Form.Label className="field-label fw-medium text-uppercase text-secondary mb-0">
        {label}
      </Form.Label>
      {children}
    </div>
  );
}
